@if (show) {
	<div class="row" [style.display]="display" [ngClass]="extraClasses">
		<div class="col-md-12" [ngClass]="textAlign">
			<fa-icon [icon]="['fas', 'spinner']" animation="spin" size="lg" [style]="{ color: color }"></fa-icon>
			@if (text) {
				<span [style.color]="color" class="ml-1">{{ text }}</span>
			}
		</div>
	</div>
}
